import { Link } from 'react-router-dom';

export default function PageNotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-background" dir="rtl">
      
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-primary/5"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 rounded-full bg-primary/5"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 rounded-full bg-accent/5"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center">

        {/* Logo */}
        <img
          src="https://media.base44.com/images/public/user_69729b1c2410c5c031f1d29a/291b90bb1_.png"
          alt="مغاسل القمر الأبيض"
          className="w-28 h-28 object-contain mb-8 drop-shadow-md"
        />

        {/* Error Number */}
        <h1 className="text-9xl font-black text-primary/20 leading-none mb-2 select-none">
          404
        </h1>

        {/* Title */}
        <h2 className="text-2xl font-black text-foreground mb-3">
          الصفحة غير موجودة
        </h2>

        {/* Description */}
        <p className="text-muted-foreground text-base max-w-xs mb-10 leading-relaxed">
          يبدو أن هذه الصفحة غير متاحة أو تم نقلها. يمكنك العودة للرئيسية أو تصفح خدماتنا.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
          <Link
            to="/"
            className="flex-1 py-3 bg-primary text-primary-foreground font-bold rounded-2xl text-center hover:bg-primary/90 transition-all shadow-md hover:shadow-lg"
          >
            🏠 الصفحة الرئيسية
          </Link>
          <Link
            to="/laundry"
            className="flex-1 py-3 border-2 border-primary/30 text-primary font-bold rounded-2xl text-center hover:bg-primary/10 transition-all"
          >
            🧺 خدماتنا
          </Link>
        </div>

        {/* WhatsApp contact */}
        <a
          href="https://wa.me/966500000000"
          target="_blank"
          rel="noreferrer"
          className="mt-8 flex items-center gap-2 text-sm text-green-600 hover:text-green-700 font-semibold transition-colors"
        >
          <span className="text-lg">💬</span>
          تواصل معنا عبر واتساب
        </a>

        {/* Brand footer */}
        <p className="mt-12 text-xs text-muted-foreground font-medium tracking-wide">
          مغاسل القمر الأبيض — خدمة متميزة بكل تفاصيلها
        </p>
      </div>
    </div>
  );
}